import React from "react";
import "./LoadingScreen.css";

export default function LoadingScreen({ message = "Getting insights for you..." }) {
  return (
    <div className="loading-screen">
      <div className="loading-screen-content">
        <div className="loading-logo">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <path d="M3 9h18M9 3v18" />
          </svg>
        </div>
        <div className="loading-spinner-wrapper">
          <div className="loading-spinner"></div>
        </div>
        <h2 className="loading-message">{message}</h2>
        <p className="loading-subtitle">Please wait while we prepare your dashboard</p>
      </div>
    </div>
  );
}
